
export default () => {

  const modalWindow = document.querySelector('.content-reviews__modal')
  const modalOverlay = document.querySelector('.content-reviews__modal-backdrop')

  if( modalWindow ) {
    const reviewLinks = document.querySelectorAll('.content-reviews__item-link')
    if( reviewLinks.length ) {
      reviewLinks.forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault()

          const reviewTextBlockList = document.querySelectorAll('.content-reviews__modal-text')
          if( reviewTextBlockList.length ) {
            reviewTextBlockList.forEach((reviewElement) => {
              reviewElement.style.display = 'none'
            })
          }

          const reviewId = element.getAttribute('data-id')
          const reviewTextBlock = document.querySelector('.content-reviews__modal-text[data-review="'+reviewId+'"]')
          if( reviewTextBlock ) {
            reviewTextBlock.style.display = 'block'
          }

          modalWindow.style.display = 'block';
          modalOverlay.style.display = 'block';

          setTimeout(() => {
            modalOverlay.classList.add('show')
            modalWindow.classList.add('show')
          }, 50)

          //event.target.nextElementSibling.classList.toggle('hidden')
          //event.target.classList.toggle('active')
        })
      })
    }

    const modalClose = () => {
      modalOverlay.classList.remove('show')
      modalWindow.classList.remove('show')
      setTimeout(() => {
        modalWindow.style.display = 'none';
        modalOverlay.style.display = 'none';
      }, 100)
    }

    modalWindow.addEventListener('click', function (e) {
      if( !e.target.closest(".content-reviews__modal-content") ) {
        modalClose()
      }
    });

    document.querySelector('.content-reviews__modal-close').addEventListener('click', function (e) {
      event.preventDefault()
      modalClose()
    });

  }
}

